import { Component } from '@angular/core';
import { DeliveryLocationsJeevesComponent } from 'gung-standard-jeeves';

@Component({
  selector: 'cult-delivery-locations',
  templateUrl: './cult-delivery-locations.component.html',
  styleUrls: ['./cult-delivery-locations.component.scss']
})
export class CultDeliveryLocationsComponent extends DeliveryLocationsJeevesComponent {
  protected afterDeliveryLocationSet(deliveryLocationId: string) {
    const newDeliveryLocation = this.deliveryLocations.find(location => location.id === deliveryLocationId);
    if (!newDeliveryLocation) {
      console.error(new Error(`Could not find delivery location: ${deliveryLocationId}`));
      return;
    }
    this.selectedDeliveryLocation = newDeliveryLocation;

    if (this.selectedDeliveryLocation.extra.fr.ftgpostadr5) {
      this.checkout.extra.procargs = this.checkout.extra.procargs || {};
      this.checkout.extra.procargs.ordlevadr1 = this.selectedDeliveryLocation.extra.fr.ftgnamn;
      this.checkout.extra.procargs.ordlevadr2 = this.selectedDeliveryLocation.extra.fr.ordlevadr5;
      this.checkout.extra.procargs.ordlevadr3 = this.selectedDeliveryLocation.extra.fr.ftgpostadr5;
      this.checkout.extra.procargs.ordlevadr4 = this.selectedDeliveryLocation.extra.fr.ftgpostlevadr3;
      this.checkout.extra.procargs.ordlevadrlandskod = this.selectedDeliveryLocation.extra.fr.landskod;
      this.checkout.extra.procargs.ordlevadrprovincecode = this.selectedDeliveryLocation.extra.fr.provincecode;
    } else {
      this.checkout.extra.procargs = this.checkout.extra.procargs || {};
      this.checkout.extra.procargs.ordlevadr1 = this.selectedDeliveryLocation.extra.fr.ftgnamn;
      this.checkout.extra.procargs.ordlevadr2 = this.selectedDeliveryLocation.extra.fr.ftgpostadr1;
      this.checkout.extra.procargs.ordlevadr3 = this.selectedDeliveryLocation.extra.fr.ftgpostadr2;
      this.checkout.extra.procargs.ordlevadrlandskod = this.selectedDeliveryLocation.extra.fr.landskod;
      this.checkout.extra.procargs.ordlevadrprovincecode = this.selectedDeliveryLocation.extra.fr.provincecode;
    }

    this.postalCode = this.selectedDeliveryLocation.extra.fr.ftglevpostnr;
    this.city =
      this.selectedDeliveryLocation.extra.fr.ftgpostlevadr3 || this.selectedDeliveryLocation.extra.fr.ftgpostadr3;

    this.assignPostalCodeAndCity(this.postalCode, this.city);

    const procargsKeys = Object.keys(this.form.getRawValue());

    const valueMap = {};
    procargsKeys.forEach(key => {
      valueMap[key] = this.checkout.extra.procargs[key] || '';
    });

    this.form.setValue(valueMap);
  }
}
